<template>
  <div style="padding-top: 1rem">
    <!--<navTitle title="工单记录" path="/user"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Message records'
      "
      path="/user"
    ></navTitle>

    <div class="info">
      <div class="info-item">
        <div class="app">
          <a href="https://wa.me/639276566528" class="whatsapp"></a>
        </div>
        <div class="hr"></div>
        <div class="email">
          Please write to us Email：B2C8647@gmail.com
        </div>
      </div>
    </div>
    <!--<div class="list">-->
      <!--<div-->
        <!--class="li"-->
        <!--v-for="item in list"-->
        <!--@click="-->
          <!--$router.push({ path: '/user/serve/details', query: { id: item.id } })-->
        <!--"-->
      <!--&gt;-->
        <!--<div class="tips" v-if="item.state == 1"></div>-->
        <!--<div class="time">Submission time:{{ item.add_time }}</div>-->
        <!--<div class="time">Message content:</div>-->
        <!--<div class="msg">{{ item.message }}</div>-->
        <!--<template v-if="item.answer">-->
          <!--<div class="time">Replied:</div>-->
          <!--<div class="comment">{{ item.answer }}</div>-->
        <!--</template>-->
        <!--<template v-if="item.state == 0">-->
          <!--<div class="time">Working status:Processing</div>-->
        <!--</template>-->
      <!--</div>-->
    <!--</div>-->
    <!--<div-->
      <!--class="btn bg-color-blue"-->
      <!--@click="$router.push({ path: '/user/serve/report' })"-->
    <!--&gt;-->
      <!--Submit message-->
    <!--</div>-->
  </div>
</template>

<script>
import navTitle from "@components/navTitle";
import { serveMsgList, getUserInfo } from "@api/user";

export default {
  name: "serveMsgList",
  components: {
    navTitle
  },
  data: function() {
    return {
      list: []
    };
  },
  watch: {
    $route(n) {
      // console.log('n.name ',n.name )
      if (n.name === "serveMsgList") {
        this.getList();
      }
    }
  },
  methods: {
    getList() {
      serveMsgList().then(res => {
        this.list = res.data;
      });
      getUserInfo();
    }
  },

  mounted() {
    this.getList();
  }
};
</script>

<style scoped>
.list {
  width: 100%;
  /*background: #fff;*/
  padding-bottom: 1.4rem;
  padding-top: 0.3rem;
}
.tips {
  position: absolute;
  right: 10px;
  top: 10px;
  /*padding: 2px 10px;*/
  width: 10px;
  height: 10px;
  border-radius: 50%;
  color: #fff;
  font-size: 0.3rem;
  background: #e92121;
}
.li {
  width: 100%;
  padding: 0.3rem;
  box-sizing: border-box;
  min-height: 1rem;
  background: #fff;
  margin-bottom: 0.3rem;
  position: relative;
}
.time {
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #fff;
  color: #666;
}
.comment {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.msg {
  width: 100%;
  border-bottom: 1px solid #eee;
  padding-bottom: 0.25rem;
  margin-bottom: 0.25rem;
}
.btn {
  width: 100%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.35rem;
  color: #fff;
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
}
.info{
  width: 100%;
  height: 100%;
  position: fixed;
  background: #1ebea5;
  /*padding-top: 1rem;*/
}
  .whatsapp{
    width: 158px;
    height: 59px;
    margin: 0 auto;
    background: url("../../../assets/images/whatsAPP.svg") no-repeat;
    display: block;

  }
  .hr{
    width: 80%;
    margin: 0.4rem auto;
    height: 1px;
    background: #fff;
  position: relative;
  }
  .hr:after{
    content: "or";
    padding: 3px;
    background: #1ebea5;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.25rem;
    margin:0 auto ;
    width: 1rem;
    text-align: center;
    color: #fff;
  }
  .email{
    width: 100%;
    /*height: 200px;*/
    color: #fff;
    text-align: center;
  }
  .info-item{
    top: -1rem;
    bottom: 0;
    width: 100%;
    height: 2.5rem;
    margin:  auto auto;
    position: absolute;
  }
</style>
